import { createApp } from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import VueAnimXyz from '@animxyz/vue3';
import './style.scss';
import '@animxyz/core'; // Import css here if you haven't elsewhere

createApp(App).use(router).use(VueAnimXyz).mount('#app');
